enum AuthPages {
  auth = 'auth',
  login = 'login',
  forgot = 'forgot',
  appChooser = 'app-chooser',
  activation = 'activation',
}

export type AppRoutes = typeof AppRoutes;
export const AppRoutes = {
  ...AuthPages
};
